<template>
  <div class="notice">
    <svg
      class="notice__icon"
      width="17" height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <path d="M12 8v5M12 16h.01"/><circle cx="12" cy="12" r="9"/>
    </svg>
    <div>
      <strong v-if="title">{{ title }}</strong>
      <span class="notice__body"><slot></slot></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notice-banner',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.notice {
  display: flex;
  gap: 11px;
  align-items: flex-start;
  background: var(--brand-soft);
  border-radius: var(--radius);
  border-left: 3px solid var(--brand);
  padding: 12px 14px;
  font-size: 13px;
  color: var(--ink);
}
.notice__icon { flex: none; margin-top: 1px; color: var(--brand-dark); }
.notice strong { font-weight: 700; margin-right: 4px; }
.notice__body { color: var(--muted); }
</style>
